import Icon from "../../../../components/Icon/Icon";

export default function SearchBar({className, inputClassName, onSearchButtonClick, ...props}) {

    return (
        <div className={`h-10  relative ${className}`}>
            <div onClick={onSearchButtonClick}
                 className={"h-8 w-8 right-1 cursor-pointer top-1 flex justify-center items-center bg-secondary-900 rounded-full  transition-transform   absolute"}>
                <Icon className={"w-4"} name={"search"}/>
            </div>
            <input
                className={`w-full bg-tertiary-50 h-10 px-3 pr-8 text-sm text-gray-700 placeholder-gray-400  border border-tertiary-800 rounded-full shadow-sm appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${inputClassName}`}
                {...props}
            />

        </div>

    )
}